import { Game, GAME_STATUS } from '@/fixtures/games'

export const sortByStatusAndPriority = (games: Game[], allowed: GAME_STATUS[]) =>
  sortByPriority(games.filter((game) => allowed.includes(game.status)))

export const sortByPriority = (games: Game[]) => games.sort((a, b) => a.displayPriority - b.displayPriority)
